








































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {CarInfoModel} from "@/model/car-info/car-info.model";
import {UserInfoForUpdateTmpModel} from "@/model/user-info/user-info-for-update-tmp.model";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import CarInfoDelete from "@/component/mypage/car-info-delete.vue";
import CarInfoEdit from "@/component/mypage/car-info-edit.vue";
import {CarInfoInputModel} from "@/model/car-info/car-info-input.model";
import {DisplayUtils} from "@/display-utils";
import {CommonConstant} from "@/common-constant";

@Component({
    components: {CarInfoDelete, CarInfoEdit}
})
export default class CarInfoView extends Vue {
    @Prop() private model!: UserInfoForUpdateTmpModel;

    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    // 選択しているお車情報
    selectedCar: CarInfoModel = new CarInfoModel;

    // 登録の場合true、編集の場合false
    isRegister: boolean = false

    // お車情報登録編集画面の表示フラグ
    showCarInfoEditFlg: boolean = false;

    // お車情報削除画面の表示フラグ
    showCarInfoDeleteFlag: boolean = false;

    // お車情報削除後にファーストカーに設定する車両のID
    nextFirstCarId: string = null;

    /** ファーストカー区分の設定 */
    setFirstCar(value: CarInfoModel) {
        // すでにファーストカーの場合は処理を終了
        if (value.isFirst) {
            return;
        }
        // ファーストカー区分を更新する
        axios.patch("/carinfo/first-car", {id: value.id})
            .then(() => {
                let seconds: Array<CarInfoModel> = this.model.cars
                    .filter(e => e.id !== value.id) // リストからファーストカーを削除
                    .map(e => {
                        if (e.isFirst) {
                            // 元ファーストカーはフラグを落とし更新日時を更新
                            e.isFirst = false;
                            e.setLastModifiedDatetimeNow();
                        }
                        return e;
                    }) // ファーストカー区分を再設定
                    .sort((e1, e2) => (e1.getLastModifiedDatetime().toSeconds() > e2.getLastModifiedDatetime().toSeconds()) ? -1 : 1); // 最終更新日の降順にソート

                // ファーストカーのリストを作成
                let first: Array<CarInfoModel> = this.model.cars.filter(elem => {
                    return (elem.id === value.id);
                });
                first[0].isFirst = true;
                // 更新日を更新
                first[0].setLastModifiedDatetimeNow();

                // お車情報のリストを再構築する
                this.model.cars = first.concat(seconds); // ファーストカーにセカンドカーを追加

                // スクロールを上部に戻す
                window.scrollTo(0, 0);
                this.$emit('closeCarInfoModal');
            })
            .catch(error => {
                AxiosUtils.gotoClientErrorPage(error, this.$router);
            });
    }

    /** お車情報削除画面の表示 */
    showCarInfoDelete(serialNumber: number, value: CarInfoModel) {
        // 背景がスクロールしないように画面を固定する
        document.body.classList.add('modal-opened');

        // お車情報に番号を設定し、選択したお車情報とする
        let carModel = new CarInfoModel();
        carModel.copy(value as CarInfoModel);
        carModel.displayId = String(serialNumber);
        this.selectedCar = carModel;

        // 削除後にファーストカーに指定する車両のID
        this.nextFirstCarId = this.getNextFirstCarId(value);

        // ダイアログを表示する
        this.showCarInfoDeleteFlag = true;
    }

    /** お車情報削除画面の非表示 */
    closeCarInfoDelete(id: string, nextFirstCarId: string) {
        // 削除した車両のIDが指定された場合
        if (id) {
            // SFのAPIからの戻り値でファーストカーのIDが返却された場合、返却されたお車情報IDをファーストカーとする
            if (nextFirstCarId) {
                this.model.cars.find((car) => car.id === nextFirstCarId).isFirst = true;

                // ファーストカー以外のリスト作成
                let seconds: Array<CarInfoModel> = this.model.cars
                    .filter(e => e.id !== nextFirstCarId) // リストからファーストカーを削除
                    .sort((e1, e2) => (e1.getLastModifiedDatetime().toSeconds() > e2.getLastModifiedDatetime().toSeconds()) ? -1 : 1); // 最終更新日の降順にソート

                // ファーストカーのリストを作成
                let first: Array<CarInfoModel> = this.model.cars.filter(elem => {
                  return (elem.id === nextFirstCarId);
                });

                // お車情報のリストを再構築する
                this.model.cars = first.concat(seconds);
            }

            // 削除したお車情報を一覧から削除する
            this.model.cars = this.model.cars.filter(elem => {
                return (elem.id !== id);
            });
            this.$emit('closeCarInfoModal');
        }

        // 背景の固定を解除する
        document.body.classList.remove('modal-opened');

    // ダイアログを閉じる
    this.showCarInfoDeleteFlag = false;
  }

    /** ファーストカー区分のキャプションの切り替え */
    getFirstCarCaption(value: CarInfoModel) {
        return value.isFirst ? "ファーストカー" : "ファーストカーに設定";
    }

    /** ファーストカー区分のスタイルの切り替え */
    getFirstCarClass(value: CarInfoModel) {
        return value.isFirst ? "first-car" : "not-first-car";
    }

    /** お車情報が削除後にファーストカーに設定するお車情報のIDを返す */
    getNextFirstCarId(value: CarInfoModel): string {
        // ファーストカー、且つ、お車情報が２件以上の場合は、車両２のIDを返す。それ以外の場合はnullを返す
        return value.isFirst && (this.model.cars.length >= 2) ? this.model.cars[1].id : null;
    }

    /** お車情報登録編集画面表示 */
    showCarInfoInput(serialNumber: number, value: CarInfoModel) {
        // 背景がスクロールしないように画面を固定する
        document.body.classList.add('modal-opened');

        // お車情報に番号を設定し、選択したお車情報とする
        const carModel = new CarInfoInputModel();
        if (serialNumber) {
            // 変更の場合
            carModel.copy(value as CarInfoInputModel);
            carModel.displayId = String(serialNumber);
            this.isRegister = false;

        } else {
            // 登録の場合
            this.isRegister = true;
        }
        carModel.initialize().then(() => carModel.holdReaTimeSize());
        this.selectedCar = carModel;
        // ダイアログを表示する
        this.showCarInfoEditFlg = true;
    }

    /** お車情報登録更新画面非表示 */
    closeCarInfoEdit(isUpdate: boolean = false) {
        if (isUpdate) {
            if (this.selectedCar.displayId) {
                // 更新の場合は更新前のお車情報を削除
                this.model.cars.splice(Number(this.selectedCar.displayId) - 1, 1);
            }
            if (this.selectedCar.isFirst) {
                // ファーストカーなら先頭に追加
                this.model.cars.unshift(this.selectedCar);
            } else {
                // ファーストカーでははない場合は2番目に追加
                this.model.cars.splice(1, 0, this.selectedCar);
            }
          this.$emit('closeCarInfoModal');
        }
        this.showCarInfoEditFlg = false;
        // 背景の固定を解除する
        document.body.classList.remove('modal-opened');
    }

    /** BSECからの遷移の場合に表示するメッセージの判定 */
    isShownLogoutMessage() {
        // BSECから遷移、かつ、redirectUrlが指定されている場合
        return DisplayUtils.isBsecMode() && sessionStorage.getItem("redirectUrl");
    }

    /** ログアウトした後、元のサービスにリダイレクトする */
    logoutAndRedirect() {
        let params = `?redirect_uri=${encodeURIComponent(sessionStorage.getItem("redirectUrl"))}`;
        axios.get(`/logoutAndRedirect${params}`).then(cb => {
            if (cb.data) {
               sessionStorage.clear();
               window.location.href = cb.data.toString();
            } else {
               // URLが指定されていない場合、エラー画面へ遷移
               this.$router.push("/client/error");
            }
        }).catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
    }
}
